import Vue from 'vue'
import VueI18n from 'vue-i18n'
import BaseConfig from '@/config/base.js'

import * as EN from './JsonModule/en.js'
import * as PT from './JsonModule/pt.js'
import * as ES from './JsonModule/es.js'
import * as AR from './JsonModule/ar.js'
import * as TR from './JsonModule/tr.js'
import * as FR from './JsonModule/fr.js'
import * as ID from './JsonModule/id.js'
import * as DE from './JsonModule/de.js'
import * as IT from './JsonModule/it.js'
import * as DA from './JsonModule/da.js'
import * as UK from './JsonModule/uk.js'
import * as Pl from './JsonModule/pl.js'
import * as RU from './JsonModule/ru.js'
import * as TH from './JsonModule/th.js'
import * as VI from './JsonModule/vi.js'
import * as BN from './JsonModule/bn.js'
import * as HE from './JsonModule/he.js'
import * as RO from './JsonModule/ro.js'
import * as FA from './JsonModule/fa.js'
import * as MS from './JsonModule/ms.js'
import * as AZ from './JsonModule/az.js'

import Client from '@/assets/scripts/client'

Vue.use(VueI18n)

// prettier-ignore
const messages = {
  'en': EN, // 英语
  'pt': PT, // 葡萄牙语
  'es': ES, // 西班牙语
  'ar': AR, // 阿拉伯语
  'tr': TR, // 土耳其语
  'fr': FR, // 法语
  'id': ID, // 印尼语
  'de': DE, // 德语
  'it': IT, // 意大利语
  'da': DA, // 丹麦语
  'uk': UK, // 乌克兰语
  'pl': Pl, // 波兰语
  'ru': RU, // 俄语
  'th': TH, // 泰语
  'vi': VI, // 越南语
  'bn': BN, // 孟加拉语
  'he': HE, // 希伯来语
  'ro': RO, // 罗马尼亚语
  'fa': FA, // 波斯语
  'ms': MS, // 马来语
  'az': AZ, // 阿塞拜疆语
};

export function setI18nLanguage(lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  // 右对齐
  if (BaseConfig.rtlLangs.includes(lang)) {
    document.querySelector('html').setAttribute('dir', 'rtl')
  }
  // 左对齐
  else {
    document.querySelector('html').removeAttribute('dir')
  }
  return lang
}

export function getLanguage() {
  const chooseLanguage = Client.getAppInfoLang()
  if (chooseLanguage) {
    return chooseLanguage
  }
  return ''
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
})

export default i18n
